const bigWords = document.querySelectorAll('.big-word');

if (bigWords) {
  //Set height to big-word container
  bigWords.forEach(bigWord => {
    var svg = bigWord.querySelector('svg');
    var rect = svg.getBoundingClientRect();

    // Get the witdh of the SVG and set it to the .big-word div (oldest parent)
    bigWord.setAttribute("style", "height:" + rect.height + "px");

    // Animation
    const observer = new IntersectionObserver(handleIntersection);

    observer.observe(bigWord);
  });
}

function handleIntersection(entries, observer) {
  entries.forEach((entry) => {

    if (entry.isIntersecting) {
      
      var lastScrollTop = 0;

      if(window.innerWidth > 1020) {
        window.addEventListener('scroll', function () {
          var scrollPosition = window.scrollY;
          var total = document.documentElement.offsetHeight - scrollPosition;
          var figure = entry.target.querySelector('.big-word__word figure');
          var value = 20 * (scrollPosition/total);
  
          const pageHeight = document.documentElement.scrollHeight;
          const halfwayPoint = pageHeight / 2;
  
          if (scrollPosition < lastScrollTop) {
            // User is scrolling up
            figure.style.transform = "translateX(" + value + "%)";
            figure.style.transition="all .2s" ;
          } else {
            // User is scrolling down
            figure.style.transform = "translateX(" + value + "%)";
            figure.style.transition="all .2s" ;
          }
          
          // User scroll is on top
          if (scrollPosition === 0) {
            figure.style.transform = "translateX(0)";
            figure.style.transition="all .2s" ;
          }
          
          if(scrollPosition >= halfwayPoint) {
            // User has scrolled down at least 50% of the page
            figure.style.transform = "translateX(" + value / 6 + "%)";
            figure.style.transition="all .2s" ;
          } else if (scrollPosition < lastScrollTop) {
            // User is scrolling up
            figure.style.transform = "translateX(" + value / 6 + "%)";
            figure.style.transition="all .2s" ;
          }
  
          lastScrollTop = scrollPosition;
        });
      }

      if (entry.intersectionRatio > 0) {
        observer.unobserve(entry.target);
      }
    }
  });
}